import { render, staticRenderFns } from "./df-product-datails-data.vue?vue&type=template&id=61f281be"
import script from "./df-product-datails-data.ts?vue&type=script&lang=js&external"
export * from "./df-product-datails-data.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports